import { PointLoad, DistLoad } from './load.js'
class NodeClass {
  constructor(x, support) {
    this.x = x;
    this.support = support;
  }
}

export class SpanClass {
  constructor(x1, x2) {
    this.x1 = x1;
    this.x2 = x2;
  }

  length() {
    return this.x2 - this.x1;
  }
}

function nodeSort(a, b){ return a.x - b.x; }

export class Beam {
  constructor() {
    this.nodes = [];
    this.spans = [];
    this.pointLoads = [];
    this.distLoads = [];
    this.linearLoads = [];
    this.momentOfInertia = 50
    this.elasticModulus = 29000000
  }

  addNode( x, support ) {
    this.nodes.push(new NodeClass(x, support))
    this.nodes.sort( nodeSort )
    this.rebuildSpans()
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  addLeftSpan(length) {
    for( let i = 0 ; i < this.nodes.length; i++ ) {
      this.nodes[i].x += length
    }
    this.addNode(0, "pinned")
  }

  addRightSpan(length) {  
    const x = length + this.totalLength();
    this.addNode(x, "pinned")
  }
  
  removeSpan(index) {
    var originalLength = this.totalLength()
    const delta = this.spans[index].x2 - this.spans[index].x1
    var nodeIndex = index + 1
    
    this.nodes.splice(nodeIndex, 1)
    this.nodes.sort(nodeSort)
    for( let i = nodeIndex; i < this.nodes.length; i++ ) {
      this.nodes[i].x -= delta;
    }
    this.rebuildSpans()
    this.checkStability()
    this.validateLoads(delta, originalLength)
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  updateSpan(spanNumber, spanLength) {
    const delta = spanLength - this.spans[spanNumber].length()
    for( var i = spanNumber + 1; i < this.nodes.length; i++ ) {
        this.nodes[i].x += delta
    }
    this.nodes.sort(nodeSort)
    this.rebuildSpans()
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  rebuildSpans() {
    this.spans = [];
    for( let i = 0; i < this.nodes.length-1; i++ ) {
      let x1 = this.nodes[i].x
      let x2 = this.nodes[i+1].x
      this.spans.push( new SpanClass( x1, x2 ) )
    }
  }

  addDistLoad(x1, x2, D, D2, isLinear) {
    if( x1 > this.totalLength() ) x1 = this.totalLength()
    if( x1 < 0 ) x1 = 0
    if( x2 > this.totalLength() ) x2 = this.totalLength()
    if( x2 < 0 ) x2 = 0
    this.distLoads.push(new DistLoad(x1, x2, D, D2, isLinear))
    this.distLoads.sort( function(a, b){return a.Length() < b.Length() } )
    this.rebuildSpans()
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  updateDistLoad(index, x1, x2, D, D2, isLinear) {
    if( x1 > this.totalLength() ) x1 = this.totalLength()
    if( x1 < 0 ) x1 = 0
    if( x2 > this.totalLength() ) x2 = this.totalLength()
    if( x2 < 0 ) x2 = 0
    const l = this.distLoads[index]
    l.x1 = x1
    l.x2 = x2
    l.D = D
    l.D2 = D2
    l.isLinear = isLinear
    this.rebuildSpans()
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  removeDistLoad(index) {
    this.distLoads.splice(index, 1)
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  addPointLoad( x, D, isMoment ) {
    if( x > this.totalLength() ) x = this.totalLength()
    if( x < 0 ) x = 0
    this.pointLoads.push( new PointLoad( x, D, isMoment ) )
    this.rebuildSpans()
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  updatePointLoad(index, x, D, isMoment) {
    const l = this.pointLoads[index]
    l.x = x
    l.D = D
    l.isMoment = isMoment
    this.rebuildSpans()
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  removePointLoad(index) {
    this.pointLoads.splice(index, 1 )
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  totalLength() {
    if( this.nodes.length <= 1 ) {
        return 0
    }

    let totalLength = 0
    for(let i = 0; i < this.nodes.length-1; i++) {
      let x1 = this.nodes[i].x
      let x2 = this.nodes[i+1].x
      //just in case the nodes are "reversed"
      const dist = Math.abs(x2-x1)
      totalLength += dist
    }
    return totalLength
  }

  cycleSupport(index) {
    //"free" -> "roller" -> "pinned" -> "fixed" ->
    const support = this.nodes[index].support
    if( support == "free" ) this.nodes[index].support = "pinned";
    else if( support == "pinned" ) this.nodes[index].support = "fixed";
    else if( support == "fixed" ) this.nodes[index].support = "free";
    this.checkStability();
    document.dispatchEvent(new CustomEvent('update-views'))
  }

  checkStability() {
    //1. at least 1 fixed support
    //2. 1 pin and 1 roller
    //3. 2 pins
    //4. 2 pins
    let stable = false;
    let roller_or_pin_count = 0;
    for( var i = 0; i < this.nodes.length; i++ ) {
      if( this.nodes[i].support == "fixed"){
        stable = true;
        break;
      }
      if( this.nodes[i].support == "pinned" ||
        this.nodes[i].support == "roller"){
        roller_or_pin_count++;
        if( roller_or_pin_count > 1 ){
            stable = true;
            break;
        }
      }
    }
    //update solve button...
    if( stable ){
        //document.getElementById('design-this-beam-text').removeAttribute('disabled')
        //document.getElementById('design-this-beam-text').innerHTML = ' Calculate'
        return true;
    } else {
        //document.getElementById('design-this-beam-text').setAttribute('disabled', true)
        //document.getElementById('design-this-beam-text').innerHTML = ' Beam is Not Stable - Add Another Support'
        return false;
    }
  }

  validateLoads() {

  }
}
